exports.components = {
  "component---src-pages-hodnoceni-zakazniku-js": () => import("./../../../src/pages/hodnoceni-zakazniku.js" /* webpackChunkName: "component---src-pages-hodnoceni-zakazniku-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kontakt-js": () => import("./../../../src/pages/kontakt.js" /* webpackChunkName: "component---src-pages-kontakt-js" */),
  "component---src-pages-services-js": () => import("./../../../src/pages/services.js" /* webpackChunkName: "component---src-pages-services-js" */)
}

